/**
 * Shared trade utility functions.
 * Centralized logic for determining actual trade entries vs skipped trades.
 */

const SKIPPED_REASONS = ['no_entry', 'no_data', 'SKIPPED_BY_DEDUP', 'SKIPPED_BY_RISK'];

/**
 * Check if a trade was actually entered (not skipped/no-entry).
 */
export const isActualEntry = (t) => {
  return t.exitReason && !SKIPPED_REASONS.includes(t.exitReason);
};

export { SKIPPED_REASONS };
